export default __webpack_public_path__ + "static/logo-d623643b5c82b7461035b1d4d9953f23.svg";